import { EMBED_PARAMS, YOUTUBE_URL_REGEX, YOUTUBE_EMBED_URL } from '../../constants'
import { Provider } from 'modules/transmission/types'

class YoutubeHelper {
  private static getIdFromLiveUrl = (url: string) => {
    return YOUTUBE_URL_REGEX.LIVE.test(url)
      ? url.replace(/^\S+\/live\//, '').replace(/\?\S+$/, '')
      : ''
  }

  private static getIdFromRegularURL = (url: string) => {
    let id = ''

    if (YOUTUBE_URL_REGEX.REGULAR.test(url)) {
      if (URLSearchParams) {
        const urlSearchParams = new URLSearchParams(url.split('?')[1])

        id = urlSearchParams.get('v') || ''
      } else {
        id = url.split('=').pop() || ''
      }
    }

    return id
  }

  private static getIdFromShortUrl = (url: string) => {
    let id = ''

    if (YOUTUBE_URL_REGEX.SHORT.test(url)) {
      const routes = url.replace(YOUTUBE_URL_REGEX.SHORT, '').split('/')

      id = routes[0].split('?')[0]
    }

    return id
  }

  private static getIdFromFullscreenPlayerURL = (url: string) => {
    let id = ''

    if (YOUTUBE_URL_REGEX.FULLSCREEN_PLAYER.test(url)) {
      const routes = url.replace(YOUTUBE_URL_REGEX.FULLSCREEN_PLAYER, '').split('/')

      id = routes[0].split('?')[0]
    }

    return id
  }

  static getIdFromUrl = (url: string): string => {
    const id = YoutubeHelper.getIdFromLiveUrl(url)
      || YoutubeHelper.getIdFromRegularURL(url)
      || YoutubeHelper.getIdFromShortUrl(url)
      || YoutubeHelper.getIdFromFullscreenPlayerURL(url)

    if (!id) {
      console.error(`Failed to extract id from Youtube url "${url}"`)
    }

    return id
  }

  static getEmbedURL = (url: string) => {
    const mediaYoutubeId = YoutubeHelper.getIdFromUrl(url)
    const params = EMBED_PARAMS[Provider.YOUTUBE]?.join('&') || ''

    return `${YOUTUBE_EMBED_URL.replace(':id', mediaYoutubeId)}?${params}`
  }
}

export default YoutubeHelper
